<template>
  <div v-on:click="click" class="text" :style="isSelect ? 'color: #0052ce' : ''">{{ text }}</div>
</template>
<script>
export default {
  name: 'TextHover',
  props: {
    text: {
      type: String,
      default: ''
    },
    isSelect: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>
<style>
.text:hover {
  color: #000000;
  cursor: pointer;
}
</style>
